module.exports = __webpack_public_path__ + "Roboto-Regular.99b14f0da0591e0d7167.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Regular.ttf
// module id = 149
// module chunks = 10